import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "antd";
import { get_booking } from "../../../../Controllers/Sales/Bookings";
import Header from "../../../../Componets/Header";
import headers from "../../../../Data/Forms/Sales/Bookings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import A4Invoice from "./a4Invoice";

const BookingView = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    let [searchParams] = useSearchParams();

    const bookingA4Ref = useRef();

    const handleA4Print = useReactToPrint({
        content: () => bookingA4Ref.current,
    });

    const [loader, setLoader] = useState(false);
    const [values, setValues] = useState();
    const [header, setHeader] = useState(headers);
    const [returnPage, setReturnPage] = useState(1);

    const handleData = (booking) => {
        const modifiedDetails = booking.details.map((item) => ({
            ...item,
            tax: item.tax?.rate ?? 0,
        }));

        const updatedBooking = { ...booking, details: modifiedDetails };
        setValues(updatedBooking);
        setLoader(false);
    };

    const fetchData = async () => {
        if (id) {
            setLoader(true);

            const booking = await get_booking({ id });

            if (booking?.status) {
                handleData(booking?.data);
            } else {
                toast?.error(booking?.message);
                setLoader(false);
            }
        } else {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
        const pageParam = searchParams.get("returnPage");
        if (pageParam) {
            setReturnPage(parseInt(pageParam));
        }
    }, [id, searchParams]);

    const handleBack = () => {
        const page = returnPage || 1;
        navigate(`/app/sales/bookings?page=${page}`);
    };

    const totalDeposited = values?.deposit?.reduce(
        (sum, d) => sum + parseFloat(d?.amount || 0),
        0
    ) || 0;

    const remaining = Math.max(
        0,
        parseFloat(values?.total || 0) - totalDeposited
    );

    return (
        <Header headers={header} setHeaders={setHeader}>
            <Loadercomponent loader={loader}>

                <div className="pb-8">
                    <div className="flex justify-end flex-wrap gap-2">
                        <div className="p-2" onClick={handleBack}>
                            <Button size="large">Back</Button>
                        </div>
                        <div className="p-2" onClick={handleA4Print}>
                            <Button size="large">
                                A4 Print <PrinterOutlined className="text-lg" />
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Deposit summary banner */}
                {values && (
                    <div className="mb-6 flex gap-6 flex-wrap px-2">
                        <div className="border rounded-lg p-4 shadow-sm flex-1 min-w-[180px]">
                            <div className="text-xs text-gray-500 mb-1">Booking Total</div>
                            <div className="text-lg font-semibold text-black">
                                OMR {parseFloat(values?.total || 0).toFixed(3)}
                            </div>
                        </div>
                        <div className="border rounded-lg p-4 shadow-sm flex-1 min-w-[180px]">
                            <div className="text-xs text-gray-500 mb-1">Total Deposited</div>
                            <div className="text-lg font-semibold text-green-600">
                                OMR {totalDeposited.toFixed(3)}
                            </div>
                        </div>
                        <div className="border rounded-lg p-4 shadow-sm flex-1 min-w-[180px]">
                            <div className="text-xs text-gray-500 mb-1">Remaining Balance</div>
                            <div className="text-lg font-semibold text-orange-600">
                                OMR {remaining.toFixed(3)}
                            </div>
                        </div>
                        <div className="border rounded-lg p-4 shadow-sm flex-1 min-w-[180px]">
                            <div className="text-xs text-gray-500 mb-1">Status</div>
                            <div className="text-lg font-semibold capitalize">
                                {values?.status || "—"}
                            </div>
                        </div>
                    </div>
                )}

                <ScrollWrapper>
                    <div>
                        <A4Invoice ref={bookingA4Ref} values={values} />
                    </div>
                </ScrollWrapper>

            </Loadercomponent>
        </Header>
    );
};

export default BookingView;